module.exports = __webpack_public_path__ + "img/payments.37c407f0.svg";